import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import { snapshot } from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import { IManagementTool, IToolRunContext } from '../models/management-tool';
import {
  ViewDataDialogComponent,
  type IViewDataDialogData,
} from '../view-data-dialog/view-data-dialog.component';

@Injectable({ providedIn: 'root' })
export class ViewDataTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'view-data';
  readonly label = 'View Data';
  readonly icon = 'data_object';
  readonly description = 'View the raw data for this resource';
  readonly resource = ManagementResource.Data;

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value) {
      return;
    }
    const data: IViewDataDialogData = {
      title: await snapshot(context.resource.label$),
      data: value,
    };
    this._dialog.open(ViewDataDialogComponent, DialogPresets.large({ data }));
  }
}
